import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingBuildings = function () { return utilBalancing.getBalancing().Buildings; };
export var selectBalancingBuilding = function (buildingId) {
    return selectBalancingBuildings().get(buildingId);
};
export var selectBalancingRelatedBuildings = memoize(function (buildingId) {
    var targetBuilding = selectBalancingBuilding(buildingId);
    if (targetBuilding == undefined) {
        return [];
    }
    var buildings = selectBalancingBuildings();
    return Array.from(buildings.values()).filter(function (element) { return element.shopCategory === targetBuilding.shopCategory; });
});
export var balancingBuildingsMemoizedFunctions = [
    selectBalancingBuildings,
    selectBalancingBuilding,
    selectBalancingRelatedBuildings,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingBuildings.ts
// module id = 190
// module chunks = 3